function isMobile() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /android|avantgo|blackberry|bada\/|bb|meego|mmp|palm|phone|pie|pocket|psp|silk|symbian|tablet|up\.browser|up\.link|webos|wos/i.test(userAgent);
}

export {
    isMobile
}